import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { ChevronDown } from 'react-feather';
import defaultStyles from './styles/Select.module.scss.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { omit } from '../../utils/omit.js';

const Option = ({
  value,
  content,
  disabled
}) => /*#__PURE__*/jsx("option", {
  value: value,
  disabled: disabled,
  children: content
});
const Placeholder = ({
  text
}) => /*#__PURE__*/jsx("option", {
  value: "",
  disabled: true,
  selected: true,
  children: text
});
const Group = ({
  label,
  options
}) => /*#__PURE__*/jsx("optgroup", {
  label: label,
  children: options.map(({
    value,
    ...rest
  }) => /*#__PURE__*/jsx(Option, {
    ...rest
  }, value))
});
const NativeSelect = /*#__PURE__*/forwardRef(({
  disabled,
  multiple,
  name,
  options,
  onChange,
  placeholder,
  theme,
  size = 'md',
  arrowIconProps = {
    hasBorder: true,
    iconType: 'arrow'
  },
  ...restProps
}, ref) => {
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  const sizeClassNames = clsx({
    [styles.xs]: size === 'xs',
    [styles.sm]: size === 'sm',
    [styles.md]: size === 'md',
    [styles.lg]: size === 'lg'
  });
  return /*#__PURE__*/jsxs("div", {
    className: styles.native_wrapper,
    children: [/*#__PURE__*/jsxs("select", {
      title: name,
      className: clsx(styles.native_root, styles.view, sizeClassNames),
      disabled: disabled,
      multiple: multiple,
      name: name,
      onChange: onChange,
      ref: ref,
      ...omit(restProps, ['size', 'arrowIconProps', 'theme']),
      children: [placeholder && /*#__PURE__*/jsx(Placeholder, {
        text: placeholder
      }), options.map(item => 'options' in item ? /*#__PURE__*/jsx(Group, {
        options: item.options,
        label: item.label
      }, item.value) : /*#__PURE__*/jsx(Option, {
        ...item
      }))]
    }), /*#__PURE__*/jsx("span", {
      className: clsx(styles.arrow, styles.native_arrow, {
        [styles.arrow_has_border]: arrowIconProps.hasBorder,
        [styles.pointers]: arrowIconProps.iconType !== 'arrow'
      }),
      children: arrowIconProps.iconType === 'arrow' ? /*#__PURE__*/jsx(ChevronDown, {}) : /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("i", {
          className: styles.pointer
        }), /*#__PURE__*/jsx("i", {
          className: styles.pointer
        })]
      })
    })]
  });
});

export { NativeSelect };
